import {
  Avatar,
  Box,
  Button,
  Container,
  Heading,
  Menu,
  MenuButton,
  MenuDivider,
  MenuGroup,
  MenuItem,
  MenuList,
  Text,
} from "@chakra-ui/react";
import { useContext } from "react";
import { AuthenticationService } from "../../../../services/AuthenticationService";
import { ContextApp } from "../../../../shared/ContextApp";
// import './AvatarWithPicture.css'

export interface IAvatarWithPictureProps {}
export default function AvatarWithPicture(props: IAvatarWithPictureProps) {
  const { logout } = AuthenticationService();
  const { user } = useContext(ContextApp);

  return (
    <>
      <Menu>
        <MenuButton
          as={Button}
          rounded={"full"}
          variant={"link"}
          cursor={"pointer"}
          minW={0}
        >
          <Avatar
            size={"sm"}
            src={user?.photoURL ? user.photoURL : undefined}
          />
        </MenuButton>
        <MenuList>
          <MenuItem onClick={logout}>Salir</MenuItem>
        </MenuList>
      </Menu>
    </>
  );
}
